export default {
  field: {
    label: 'Categorie de taxă',
    placeholder: 'Fără categorie de taxă',
    unlinked_hint:
      'Fără una, un produs folosește categoria de taxă a categoriei sale de meniu sau cota standard a restaurantului.',
    default_hint: 'Dacă este salvat fără una, primește categoria de taxă implicită a meniului.',
  },
  empty: {
    hint: 'Nu există încă categorii de taxă — adaugă una mai jos.',
    read_only_hint: 'Nu au fost configurate încă categorii de taxe.',
  },
  option: {
    varies_by_channel: '(variază în funcție de canal)',
  },
  load_error:
    'Categoriile de taxă nu au putut fi încărcate — asocierea și dezasocierea sunt dezactivate până la încărcare.',
  create: {
    name_placeholder: 'Nume categorie nouă',
    rate_placeholder: 'Cotă %',
    button: 'Adaugă categorie de taxă',
  },
  toasts: {
    create_error: 'Categoria de taxă nu a putut fi creată.',
  },
};
